module.exports = __webpack_public_path__ + "img/syukyaku-sytem-003.c5d0f6ec.jpg";